export const StatusFilter = [{
    id: 1,
    name: "Activo",
    value: "1"
},{
    id: 2,
    name: "Inactivo",
    value: "0"
}]